<span class="d-flex" [class.no-content]="!content">
    @if (icon) {
        <ws-ace-icon
            class="auto"
            [glyph]="icon">
        </ws-ace-icon>
    }
    <slot name="icon"></slot>
    <span>{{ content }}</span>
</span>
